const specialCheck = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

const sortAggs = data => {
  const {
    searchPublishedContent: {
      rawResults: { aggregations: { azCount: { buckets = [] } = {} } = {} } = {}
    } = {}
  } = data || {};

  return [...buckets].sort((a, b) => {
    if (Number(a.key) || specialCheck.test(a.key)) return 1;
    if (a.key < b.key) return -1;
    if (a.key > b.key) return 1;
    return 0;
  });
};

export default sortAggs;
